import axios from "../http_v2";

export default {
  // 获取列表
  getlistUrl: (params) => {
    return axios.post("/formbuilder/form/page", params);
  },
  // 添加和更新
  addorUpdateUrl: (params) => {
    return axios.post("formbuilder/form/save", params);
  },
  //获取单个问卷
  getnaireUrl: (params) => {
    return axios.post("formbuilder/form/get", params);
  },
  // 删除
  deleteUrl: (params) => {
    return axios.post("formbuilder/form/delete", params);
  },
  // 导出收集的数据
  exportUrl: (params) => {
    return axios.post("formbuilder/userform/export", params);
  },
  // 导出收集的数据
  exportHasNumUrl: (params) => {
    return axios.post("formbuilder/userform/export/with", params);
  },
  // 获取报表信息
  reportCount: (params) => {
    return axios.post("formbuilder/form/count", params);
  },
  // 获取报表的文本类答案
  reportInputData: (params) => {
    return axios.post("formbuilder/form/pageAnswer", params);
  },
  // 获取报表类的数据
  reportList: (params) => {
    return axios.post("formbuilder/userform/pagedetail", params);
  },
  // 批量导出
  batchexport: (params) => {
    return axios.post("formbuilder/userform/batchexport", params);
  },
  // 上传地址
  uploadApi: process.env.VUE_APP_API_ROOT + "opservice/ophonoredguest/savefile",
  // 生成http短连接服务
  generateShortUrl(params) {
    return axios.post("https://mk-api.yybip.com/y/generatecode", params);
  },
};
